export default __webpack_public_path__ + "static/media/thumbnail.e1f0bd69.png";